<div class="table-wrapper">
    <table mat-table [dataSource]="dataSource" matSort [class]="tableClass" *ngIf="tableData && tableData.length > 0">
      <ng-container
        *ngFor="let col of displayedColumns; let i = index"
        [matColumnDef]="col.field"
        [sticky]="i === stickyColumnIndex"
      >
        <th
          mat-header-cell
          *matHeaderCellDef
          [style.width]="col.width || ''"
          class="no-wrap-header"
        >
          <div *ngIf="col.sortable; else notSortable" mat-sort-header>
            {{ col.label }}
          </div>
          <ng-template #notSortable>{{ col.label }}</ng-template>
        </th>
    
        <!--Using directive to trim the long text when flag is sent-->
        <ng-container *ngIf="col.hasLargeText;else normalText">
          <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="col.tdClass || ''"
          [style.width]="col.width || ''"
          class="text-break text-lg"
          [cvaTrimText]="element[col.field]"
          [title]="col.label"
          [maxLength]="maxLength"
        >{{ element[col.field] }}</td>
        </ng-container>


        <ng-container *ngIf="col.isVital; else normalText">
          <td mat-cell *matCellDef="let element">
            @if(element[col.field] && element[col.field].length > 0){
              @if(element[col.field].length > 1){
              <ng-template #popContent>
                @for(item of element[col.field]; track item.time){
                <div>{{item.time}} - {{item.value}}</div>
                }
              </ng-template>
              <div [popoverTitle]="col.label" [ngbPopover]="popContent" popoverClass="long-text-popover" class="show-more">
              show more
              </div>
              }@else{
              {{element[col.field][0].value}}
              }
            }
          </td>
        </ng-container>
    
        <!--Handling the table cell content normally depending on the condition-->
        <ng-template #normalText>
          <td
            mat-cell
            *matCellDef="let element"
            [ngClass]="col.tdClass || ''"
            [style.width]="col.width || ''"
          >
          @if (col.transform) {
            {{col.transform(element)}}
          }@else if (col.eventType && col.icon) {
            <button type="button" [matTooltip]="element.transcription"
            mat-icon-button
            *ngIf="!element.isDeleted"
            [ngClass]="{ 'disabled': !element[col.field] }"
            (click)="onAction($event, element,  col.eventType)"
          >
            @if (col.field === "hasTranscription") {
              <img [src]="element[col.field] ? (element['pastAppointment'] ? col.readOnlyIcon : col.icon) : col.disabledIcon" [alt]="col.label" class="icon">
            } @else {
              <img [src]="element[col.field] ? col.icon : col.disabledIcon" [alt]="col.label" class="icon">
            }
          </button>
    
          } @else if(isToTitleCaseColumn){
            {{ element[col.field] | toTitleCase }}
          }@else{
          {{element[col.field]}}
          }
          </td>
        </ng-template>
    
      </ng-container>
    
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let element" class="action-td">
          <span
            class="d-flex"
            *ngIf="!element.isDeleted"
            [ngClass]="{ 'disabled-row': element.isDeleted }"
          >
            <button type="button"
              mat-icon-button
              *ngIf="isEditable"
              (click)="onAction($event, element, 'edit')"
            >
              <i class="bi bi-pencil"></i>
            </button>
            <button type="button"
              mat-icon-button
              *ngIf="isDeletable"
              [ngClass]="{ 'disabled-row': element.hasTranscription || element.pastAppointment}"
              (click)="onAction($event, element, 'delete')"
            >
              <i class="bi bi-trash3"></i>
            </button>
          </span>
        </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="allColumns"></tr>
    
      <tr onKeyDown="doNothing();" tabindex="0"
        mat-row
        *matRowDef="let row; columns: allColumns"
        (click)="!row.isDeleted && isRowClickable ? onRowClicked(row) : false"
        [ngClass]="{
          pointer: !row.isDeleted && isRowClickable,
          'disabled-row': row.isDeleted
        }"
      ></tr>
    
    </table>
    <div [hidden]="!showPagination">
      <mat-paginator
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        showFirstLastButtons
        aria-label="Select page of periodic elements"
        [hidePageSize]="hidePageSize"
      >
      </mat-paginator>
    </div>
    @if(!tableData || tableData.length === 0) {
      <div class="no-records-found">
        <strong> No Record Found. </strong>
      </div>
      }
</div>